import { mapState, mapGetters } from 'vuex';
import store from '@/store/store';
import flatpickr from 'flatpickr';

import EmailModal from '@/components/ui/modals/EmailModal/EmailModal.vue';
import SmsModal from '@/components/ui/modals/SmsModal/SmsModal.vue';
import ClientData from '@/components/clients/ClientData/ClientData.vue';
import WardrobeElements from './WardrobeElements/WardrobeElements.vue';
import WardrobeMaterials from './WardrobeMaterials/WardrobeMaterials.vue';

import config from '@/config';

// PARTID 2 - Wardrobe
// PARTID 1 - Doors

export default {
  data() {
    return {
      columns: [
        {
          label: 'Название элемента',
          field: 'elementTitle'
        },
        {
          label: 'Количество',
          field: 'qty'
        },
        {
          label: 'Цена',
          field: 'price'
        },
        {
          label: 'Стоимость',
          field: 'cost'
        }
      ]
    };
  },

  props: {
    action: {
      default: false
    },
    orderId: {
      required: true
    }
  },

  computed: {
    ...mapState({
      order: state => state.orders.currentOrder,
      orderStatuses: state => state.user.orderStatuses
    }),

    ...mapGetters(['getStatusName', 'getConstructorName']),

    wardrobe() {
      return this.order.constructors.filter(
        part => part.partId === config.constructors.wardrobeId
      )[0];
    },

    doors() {
      return this.order.constructors.filter(
        part => part.partId === config.constructors.doorsId
      )[0];
    },

    wardrobePrice() {
      return this.wardrobe.prices.totalPrice;
    },

    wardrobeCost() {
      return this.wardrobe.prices.costPrice;
    },

    doorsPrice() {
      return this.doors.prices.totalPrice;
    },

    doorsCost() {
      return this.doors.prices.costPrice;
    },

    totalPrice() {
      return (
        parseFloat(this.order.price) +
        parseFloat(this.order.assemblyPrice) +
        parseFloat(this.order.shippingPrice)
      );
    }
  },

  methods: {
    init(to) {
      store.commit('startLoad');
      store.dispatch('orderGet', to.params.orderId).then(() => {
        store.commit('endLoad');
      });
    },

    openEmailModal() {
      this.$refs.emailModal.open(this.order.client.contact_email, '', '', {});
    },

    openSmsModal() {
      this.$refs.smsModal.open();
    },

    onClickImage(url) {
      this.$zoom(url, {
        // When false, zooming is not available. Image will be shown on 100% size.
        allowZoom: true,
        // When true, if the image is larger than the screen, it will be automatically scaled down until suitable. Along with 'allowZoom'
        autoScale: true,
        // When false, clicking modal layer will close the viewer.
        closeOnClickModal: false
      });
    },

    onClickUpdateOrder() {
      const {
        id: orderId,
        contract_number,
        assembly_at,
        status,
        firmComments,
        customerComments
      } = this.order;

      const updatePromise = this.$store.dispatch('orderUpdate', {
        orderId,
        payload: {
          contract_number,
          assembly_at,
          status,
          firmComments,
          customerComments
        }
      });

      updatePromise.then(() => {
        this.flashSuccess('Данные обновлены');
      });

      return updatePromise;
    },

    deleteOrder() {
      const { id: orderId } = this.order;

      this.$store.dispatch('orderDelete', orderId).then(() => {
        this.$router.push({ name: 'orders' });
      });

      this.closeDeleteOrderPopup();
    },

    openDeleteOrderPopup() {
      this.$refs.orderDeleteAcceptModal.open();
    },

    closeDeleteOrderPopup() {
      this.$refs.orderDeleteAcceptModal.close();
    }
  },

  filters: {
    ceil(value) {
      if (!value) return '';
      return Math.ceil(value);
    },

    doorMaterials(arr) {
      return arr.join(' + ');
    }
  },

  beforeRouteEnter(to, from, next) {
    store.commit('startLoad');
    store.dispatch('orderGet', to.params.orderId).then(() => {
      store.commit('endLoad');
      next();
    });
  },

  mounted() {
    flatpickr(this.$refs.assemblyDate, {
      altInput: true,
      altFormat: config.flatpickr.dateOutputFormat,
      dateFormat: config.flatpickr.dateTimeInputFormat,
      mode: 'single',
      onReady(dateObj, dateStr, instance) {
        const $cal = instance.calendarContainer;

        if ($cal.querySelector('.flatpickr-clear')) {
          const $clear = $cal.querySelector('.flatpickr-clear');
          $clear.addEventListener('click', () => {
            instance.clear();
            instance.close();
          });
        } else {
          const $div = document.createElement('div');
          $div.className = 'flatpickr-clear';
          $div.innerHTML = 'Очистить';
          $cal.appendChild($div);

          $div.addEventListener('click', () => {
            instance.clear();
            instance.close();
          });
        }
      }
    });
  },

  components: {
    ClientData,
    EmailModal,
    SmsModal,
    WardrobeElements,
    WardrobeMaterials
  }
};
